import { Editor } from '@tiptap/react'

import { MentionStorageType } from '../Mention/MentionStorage'

export function getMarkdownMentionStorage(editor: Editor, mentionKey: string) {
  if (!(editor.storage.MentionStorage as MentionStorageType)[mentionKey])
    (editor.storage.MentionStorage as MentionStorageType)[mentionKey] = {
      suggestions: [],
      selected: undefined
    }
  return (editor.storage.MentionStorage as MentionStorageType)[mentionKey]
}
